import { DEFAULT_FREE_TRIAL_DAYS, CAMPAIGN_CODES, planTypes } from '@/common/constants';
import { mapGetters, mapMutations, mapActions, mapState } from 'vuex';
import { plansof } from '@/utils/chain';
import { isEmptyVal } from '@/utils';
import { pageConfig } from '@/common/service/page-config';

export default {
  data() {
    return {
      trialDays: DEFAULT_FREE_TRIAL_DAYS,
      showPlanDetail: true,
      paidPurchaseLink: '#',
      title: this.$t('billing.trial.title', [this.$t('billing.scheduler.title')]),
      trackingPlanName: this.$t('billing.trial.title', [this.$t('billing.scheduler.title')]),
      specialTrackingFlowTypes: 'Direct Purchase, pricing new add-ons, billing new add-ons'
    };
  },
  computed: {
    ...mapGetters(['getSelectedPlans', 'planMapFlat', 'getUserCurrentSubscriptions']),
    ...mapState({
      trialInfoMap: state => state.ShoppingCart.trialInfoMap
    }),
    planList() {
      return plansof(this.planMapFlat).type(this.planType).get();
    },
    selectedPlan() {
      return plansof(this.getSelectedPlans).type(this.planType).get(0);
    }
  },
  async created() {
    const selectedPlan = this.selectedPlan;
    if (!isEmptyVal(selectedPlan)) {
      this.trialDays = selectedPlan?.trialDays ?? this.trialDays;
      this.form.billingCycle = selectedPlan.billing_cycle;
      this.form.selectedNumber = selectedPlan.cartInfo?.selected_number;
    }
    if ((this.trialInfoMap[CAMPAIGN_CODES.SCHEDULER] || []).length < 2) {
      const list = await this.fetchTrialInfos(CAMPAIGN_CODES.SCHEDULER)
      if (list.length >= 2) {
        this.setPlanFreeTrial({ type: planTypes.ZOOM_SCHEDULER })
      } else {
        this.$message({
          type: 'info',
          duration: 10000,
          message: this.$t('billing.common.auto_remove_notification', [this.$t('billing.trial.title', [this.$t('billing.scheduler.title')])]),
          showClose: true
        })
        this.removePlanByKey(planTypes[planTypes.ZOOM_SCHEDULER])
      }
    } else {
      this.setPlanFreeTrial({ type: planTypes.ZOOM_SCHEDULER })
    }
  },
  methods: {
    // sync shopping cart plan to local form state
    ...mapMutations(['removePlanFreeTrial', 'setPlanFreeTrial']),
    ...mapActions(['fetchTrialInfos']),
    updateForm(isInitUpdateForm = false) {
      // BUY TRIAL - quantity can't be changed, usually is only 1
      const { quantity = 1 } = pageConfig || {};
      const shoppingCartPlan = this.getSelectedPlans.find((item) => item.type === this.planType);
      if (shoppingCartPlan) {
        this.form.category = shoppingCartPlan.category;
        this.form.billingCycle = shoppingCartPlan.billing_cycle;
        this.form.selectedNumber = quantity;
        this.oldPlanCode = shoppingCartPlan.plan_code;
        this.trialDays = shoppingCartPlan.trialDays ?? this.trialDays;
      }

      this.isInitUpdateForm = isInitUpdateForm;
      this.afterSwitchCycleTracking();
    },
    clickBuyNow(event) {
      this.removePlanFreeTrial({
        type: this.formPlan.type
      });
      event?.preventDefault?.();
    },
    afterSwitchCycleTracking() {
      // event tracking
      const billingCycle = this.selectedPlan?.billing_cycle;
      billingCycle &&
        this.$tracking.buyInteraction(
          `${this.trackingPlanName} plan`,
          this.$t(`billing.billing_cycle.${billingCycle}`)?.toLowerCase(),
        );
    },
  },
};
